/** Keep the same Set when the ancestor groups are already open — a new Set every time loops React. */
export function mergeExpandedGroupIds(prev: Set<string>, ancestorIds: readonly string[]): Set<string> {
  if (ancestorIds.length === 0 || ancestorIds.every((id) => prev.has(id))) {
    return prev;
  }

  const next = new Set(prev);
  for (const id of ancestorIds) {
    next.add(id);
  }
  return next;
}
